<template>
  <div>
    <VehiclesTable class="pb-4">
      <!-- Desktop: actions dans la toolbar -->
      <template v-slot:actions="{ dataset }">
        <avs-createButton
          :data="dataset"
          :to="{ name: 'VehicleCreateUpdate' }"
          :spantext="$t('Ajouter un nouveau vehicule')"
          :name="$t('Nouveau Vehicule')"
        />

        <avs-button
          color="primary"
          iconI="mdi-upload"
          text
          @click="showImport = true"
        >
          <template v-slot:name>{{ $t('Importer') }}</template>
        </avs-button>

        <v-btn
          v-if="canToggleVehiclePhoto"
          :color="vehiclePhotoEnabled ? 'success' : 'grey darken-1'"
          outlined
          small
          class="ml-2"
          :loading="togglingPhoto"
          @click="askTogglePhoto"
        >
          <v-icon small left>{{ vehiclePhotoEnabled ? 'mdi-camera' : 'mdi-camera-off' }}</v-icon>
          {{ vehiclePhotoEnabled ? $t('Photo activee') : $t('Photo desactivee') }}
        </v-btn>
      </template>

      <!-- Mobile: uniquement le bouton Creer (PAS d'import) -->
      <template v-slot:actions-mobile="{ dataset }">
        <avs-createButton
          class="full-width"
          :data="dataset"
          :to="{ name: 'VehicleCreateUpdate' }"
          :spantext="$t('Ajouter un nouveau vehicule')"
          :name="$t('Nouveau Vehicule')"
        />
      </template>
    </VehiclesTable>

    <!-- MODAL D'IMPORT -->
    <ImportVehicleDialog v-model="showImport" @imported="onImported" />

    <!-- Confirmation toggle photo -->
    <v-dialog v-model="confirmPhoto" max-width="480" persistent>
      <v-card>
        <v-card-title class="text-h6">
          <v-icon left :color="willEnable ? 'success' : 'grey darken-1'">
            {{ willEnable ? 'mdi-camera' : 'mdi-camera-off' }}
          </v-icon>
          {{ willEnable
            ? $t('Activer la prise de photo ?')
            : $t('Desactiver la prise de photo ?') }}
        </v-card-title>
        <v-card-text>
          <p class="text-body-2 mb-0">
            {{ willEnable
              ? $t('Tous les vehicules existants seront mis a jour, et les nouveaux vehicules auront la prise de photo activee par defaut.')
              : $t('Tous les vehicules existants seront mis a jour, et les nouveaux vehicules auront la prise de photo desactivee par defaut.') }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="togglingPhoto" @click="confirmPhoto = false">
            {{ $t('Annuler') }}
          </v-btn>
          <v-btn
            :color="willEnable ? 'success' : 'grey darken-1'"
            depressed
            :dark="!willEnable"
            :loading="togglingPhoto"
            @click="doTogglePhoto"
          >
            {{ $t('Confirmer') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { VehiclesTable } from "@/components";
import { fmtCfsiData } from "@/utils/download";
import CompanyVehiclesService from "@/services/CompanyVehiclesService";
import ImportVehicleDialog from "@/components/ri3/companyVehicles/ImportVehicleDialog.vue";
import { HTTP } from "@/utils/http-common";

export default {
  name: "CompanyVehicleView",
  components: { VehiclesTable, ImportVehicleDialog },
  data() {
    return {
      showImport: false,
      togglingPhoto: false,
      confirmPhoto: false,
      willEnable: false,
    };
  },
  computed: {
    company() {
      return this.$store.getters["app/getCompany"]
    },
    vehiclePhotoEnabled() {
      return !!(this.company && this.company.vehicle_photo_required === true)
    },
    canToggleVehiclePhoto() {
      // Owner / admin / manager de la societe
      if (this.$store.getters["app/isUserSuperUser"]) return true
      if (this.$store.getters["app/isCompanyOwner"]) return true
      const role = this.company && this.company.company_role
      return role === "administrator" || role === "manager"
    },
  },
  methods: {
    preFmtData(dataset) {
      return fmtCfsiData(dataset);
    },
    onImported({ total, failed }) {
      this.$store.commit("app/message", {
        msg: failed
          ? this.$t("Import termine avec des erreurs")
          : this.$t("Import termine avec succes"),
        color: failed ? "warning" : "success",
      });
      this.$router.go();
      this.showImport = false;
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      CompanyVehiclesService.handleFileImport(this, file);
    },
    askTogglePhoto() {
      this.willEnable = !this.vehiclePhotoEnabled
      this.confirmPhoto = true
    },
    async doTogglePhoto() {
      if (!this.company || !this.company.pk) return
      this.togglingPhoto = true
      try {
        const r = await HTTP.post(
          `/business/companies/${this.company.pk}/vehicles/bulk-can-take-picture`,
          { can_take_picture: this.willEnable },
        )
        const updated = { ...this.company, vehicle_photo_required: !!r.data.vehicle_photo_required }
        this.$store.commit("app/setCompany", updated)
        this.$store.commit("app/message", {
          msg: r.data.message || this.$t("Mise a jour effectuee"),
          color: "success",
        })
        this.confirmPhoto = false
        this.$router.go()
      } catch (err) {
        const msg = err?.response?.data?.detail
          || this.$t("Echec de la mise a jour")
        this.$store.commit("app/message", { msg, color: "error" })
      } finally {
        this.togglingPhoto = false
      }
    },
  },
};
</script>

<style scoped>
.full-width {
  width: 100%;
}
</style>
